var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import Alert from "@iscr/views/NUI/Alert";
import React from "react";
import { useAsyncUpdate } from "../Hooks/useAsync";
import user_model from "@iscr/models/user_model";
import { PRIVACY_VERSION } from "@iscr/views/content/Privacy";
export const PrivacyAlert = () => {
    const [show, setShow] = React.useState(true);
    const { fn: handleSeen } = useAsyncUpdate({
        fn: () => __awaiter(void 0, void 0, void 0, function* () {
            const updProfile = { meta: { privacy_version: PRIVACY_VERSION } };
            yield user_model.save_prof(updProfile, (result) => {
                // update old profile
                if (result) {
                    app.user.prof.meta = Object.assign({}, result.profile.meta);
                }
            });
        }),
    });
    const handleClick = (e) => {
        e.preventDefault();
        app.trigger(app.events.SHOW_POPUP, { pt: "cx_txt", txt: "Privacy", pn: "privacy-policy" });
        handleSeen();
        setShow(false);
    };
    return (_jsx(Alert, { visible: show, warning: true, header: "We have updated our privacy policy.", error: undefined, success: undefined, info: undefined, afterHr: undefined, wait: undefined, ext: undefined, doc: undefined, content: _jsx("a", { onClick: handleClick, href: "#", children: "View the full policy here." }), list: undefined, className: undefined, children: undefined, onDismiss: () => {
            handleSeen();
            setShow(false);
        }, basic: undefined, bg: undefined, hideIcon: undefined }));
};
